<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Mx2zQa/tc-custom/9781782111795.jpg?1703878139720" alt="This image is the cover for the book Docherty, Canons"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Docherty, Canons
      </h1>
      <p class="bookDescription body article font2">
        <b>Whitbread Award Winner: A Scottish miner fights for a better life for his son in this “intense, witty and beautifully wrought novel” (<i>Daily Telegraph</i>).</b><br/><br/>At the dawn of the twentieth century, newborn Conn Docherty, raw as a fresh wound, lies between his parents in their tenement room, with no birthright but a life's labor in the pits of his small town on the coast of Scotland. But the world is changing, and, lying next to him, Conn's father, Tam, has decided that his son’s life will be different from his own… <br/><br/>Gritty, dark and tender, <i>Docherty</i> is a modern classic, “a serious, considered and achingly sympathetic engagement with the people whose only trace in historical record is birth and dead notices” (<i>Scotsman</i>).<br/><br/>“McIlvanney depicts the west of Scotland with a canny and ruthless insight.”—<i>Scotsman </i><br/><br/>“As a stylist Mr. McIlvanney leaves most of the competition far behind.”—<i>The New York Times Book Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William McIlvanney, Hugh McIlvanney
      </h2>
      
      <p class="authorDescription body article">William McIlvanney is known as "the father of Tartan Noir" and "Scotland's Albert Camus." His first novel, Remedy is None, won the Geoffrey Faber Memorial Prize, and with Docherty he won the Whitbread Award for Fiction. Laidlaw and The Papers of Tony Veitch both gained Silver Daggers from the Crime Writers' Association. Strange Loyalties, the third in the Detective Laidlaw trilogy, won the Glasgow Herald's People's Prize.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      SCEPTRE
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59592f2f